import { gridSize } from "@/shared";
import { Grid, TextField } from "@mui/material";
import { Control, useController } from "react-hook-form";
import { useEffect } from "react";

export type CustomTextFielReadEgresoProps<T> = {
  label: string;
  name: string;
  valueKey: keyof T;              // Para mostrar (nombre)
  actualValueKey?: keyof T;       // Para enviar al backend (codigo)
  isLoadingData: boolean;
  defaultValue: string | number | null | undefined;
  control: Control<any, any>;
  value?: T | null;
  size?: { xs: number; sm: number; md: number; lg: number };
  disabled?: boolean;
  onChangeValue?: (value: any) => void;
};

const CustomTextFielReadEgreso = <T,>({
  label,
  name,
  valueKey,
  actualValueKey,
  defaultValue,
  control,
  size = gridSize,
  disabled = false,
  value,
  onChangeValue,
}: CustomTextFielReadEgresoProps<T>) => {
  // Usamos useController para poder sincronizar en un efecto (no en render)
  const { field } = useController({
    name,
    control,
    defaultValue: defaultValue ?? "",
  });

  const displayValue = value?.[valueKey]?.toString() ?? "";
  const actualValue = actualValueKey
    ? value?.[actualValueKey]?.toString() ?? ""
    : displayValue;

  // ⬇️ La sincronización va en un useEffect, NUNCA durante el render.
  // Además solo escribe cuando ya hay un valor real (evita pisar con "" mientras carga).
  useEffect(() => {
    if (actualValue && field.value !== actualValue) {
      field.onChange(actualValue);
      onChangeValue?.(actualValue);
    }
  }, [actualValue, field.value]);

  return (
    <Grid item {...size}>
      <TextField
        {...field}
        fullWidth
        label={label}
        variant="outlined"
        value={displayValue} // Mostramos el nombre
        disabled={disabled}
        InputProps={{ readOnly: true }}
      />
    </Grid>
  );
};

export default CustomTextFielReadEgreso;